export default "__VITE_ASSET__749d52c1__"